import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { StatusBadge, Money } from "@/components/shared/Common";

export default function AdminAppointments() {
  const [a, setA] = useState([]);
  useEffect(() => { api.get("/admin/appointments").then(r => setA(r.data)); }, []);
  return (
    <div className="space-y-6">
      <div><div className="cm-eyebrow mb-2">Appointments</div><h1 className="cm-h2">All consultations</h1></div>
      <div className="cm-card overflow-x-auto">
        <table className="w-full text-sm">
          <thead className="text-left text-xs uppercase tracking-wider text-[#94a3b8] border-b border-[#e2e8f0]">
            <tr><th className="py-2 pr-4">When</th><th className="py-2 pr-4">Doctor</th><th className="py-2 pr-4">Type</th><th className="py-2 pr-4">Price</th><th className="py-2 pr-4">Payment</th><th className="py-2">Status</th></tr>
          </thead>
          <tbody>
            {a.map(x => (
              <tr key={x.id} className="border-b border-[#e2e8f0] last:border-0" data-testid={`admin-appt-${x.id}`}>
                <td className="py-3 pr-4 text-[#475569]">{(x.slot_datetime||"").replace("T"," ").slice(0,16)}</td>
                <td className="py-3 pr-4 font-medium text-[#1a2b4a]">{x.doctor_name}</td>
                <td className="py-3 pr-4 capitalize">{x.consultation_type}</td>
                <td className="py-3 pr-4 text-[#1a2b4a] font-medium"><Money amount={x.price} currency={x.currency}/></td>
                <td className="py-3 pr-4"><StatusBadge status={x.payment_status}/></td>
                <td className="py-3"><StatusBadge status={x.status}/></td>
              </tr>
            ))}
            {a.length === 0 && <tr><td className="py-3 text-[#475569]" colSpan="6">No appointments yet.</td></tr>}
          </tbody>
        </table>
      </div>
    </div>
  );
}
